import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestsService } from '../../../services/api/requests.service';
import { RequestsDateComponent } from '../components/requests-date/requests-date.component';
import { RequestsDetailsComponent } from '../components/requests-details/requests-details.component';
import { RequestsFormComponent } from '../components/requests-form/requests-form.component';
import { FormNotesCustomersComponent } from '../../customers/components/notes-customers-form/notes-customers-form.component';
import { RouteService } from '../../../services/route.service';
import { ProposalsService } from '../../../services/api/proposals.service';
import { HttpParams } from '@angular/common/http';
import { MainLayoutService } from 'src/app/services/main-layout.service';
import { AccessControlService } from 'src/app/services/access-control.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-requests-detail-page',
  imports: [RequestsFormComponent, RequestsDetailsComponent, RequestsDateComponent, FormNotesCustomersComponent],
  templateUrl: './requests-detail-page.component.html',
  styleUrl: './requests-detail-page.component.scss'
})
export class RequestsDetailPageComponent implements OnDestroy {
  requestId!: number
  request?: any;
  requestNotes?: any;
  category?: any;
  readonly: boolean;
  canEditRequest = false;
  canCreateProposal = false;
  private subscriptions = new Subscription();

  constructor(
    private route: ActivatedRoute,
    protected requestsService: RequestsService,
    private proposalsService: ProposalsService,
    private routeService: RouteService,
    private mainLayoutService: MainLayoutService,
    private accessControlService: AccessControlService
  ) {
    this.readonly = true;
  }
  ngOnInit(): void {
    this.subscriptions.add(
      this.mainLayoutService.activeProfile$.subscribe(profileCode => {
        this.canEditRequest = this.accessControlService.hasFeatureActionAccess(profileCode, 'REQUESTS_LIST', 'modify');
        this.canCreateProposal = this.accessControlService.hasFeatureActionAccess(profileCode, 'PROPOSALS_LIST', 'modify');
      })
    );
    const params = new HttpParams().set('size', '9999');
    this.requestId = Number(this.route.snapshot.paramMap.get('requestId'));
    if (this.requestId) {
      this.loadData(this.requestId);
      this.loadNotes(this.requestId, params);
    }
  }

  loadData(requestId: any) {
    this.requestsService.detail(requestId).subscribe((response: any) => {
      this.request = response.data.request;
      this.category = response.data?.request?.requestCategories;
      this.mainLayoutService.setRelatedCodeItem(this.request?.code || null);
      this.mainLayoutService.setRelatedClientName(this.request?.customer?.companyName || null);
    });
  }

  loadNotes(requestId: any, params: HttpParams) {
      this.requestsService.listNotes(requestId, { params }).subscribe(response => {
        if (response.status.code === 200) {          
          this.requestNotes = response?.data.sectionNotes;
        }
      });
    }

  proceedToProposals(): void {
    if (this.request) {
      this.routeService.proposalsCreateInitFromRequest(this.request.requestId);
    }
  }

  goToEditRequest(): void {
    if (!this.requestId) {
      return;
    }
    this.routeService.requestsUpdate(this.requestId);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.mainLayoutService.setRelatedCodeItem(null);
    this.mainLayoutService.setRelatedClientName(null);
  }
}